import { FaXmark, FaBars } from "react-icons/fa6";
import { LINKSNAVBAR } from "../../../store/LinksNavbar";
import { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { Fade } from "react-awesome-reveal";

// ***********************************************************************************************************

export default function Navbar() {
  // ***********************************************************************************************************

  const [isTrue, setIsTrue] = useState(true);
  const [inerWidth, setInerWidth] = useState(true);

  // ***********************************************************************************************************

  useEffect(() => {
    // when open page function is checked
    if (window.innerWidth < 767) {
      setInerWidth(true);
      setIsTrue(true);
    } else {
      setInerWidth(false);
    }

    // ***********************************************************************************************************

    // when resize page function is checked
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 767) {
        setInerWidth(true);
        setIsTrue(true);
      } else {
        setInerWidth(false);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ***********************************************************************************************************

  return (
    <nav>
      {inerWidth && (
        <button onClick={() => setIsTrue((e) => !e)}>
          {/* when click button will be change */}
          {isTrue ? <FaBars fontSize={30} /> : <FaXmark fontSize={30} />}
        </button>
      )}

      {/* *********************************************************************************************************** */}

      {/* animation */}
      <Fade>
        <ul
          className={`sp-sidebar-menu ${
            isTrue
              ? "max-md:-right-full max-md:opacity-0 "
              : "max-md:right-0 max-md:opacity-100"
          }`}
        >
          {/* links navbar */}
          {LINKSNAVBAR.map((obj) => (
            <li key={obj.key}>
              {/* link react-scroll when you are scroll the page */}
              <Link
                activeClass="active"
                smooth
                spy
                to={obj.link}
                className="sp-links-header"
                onClick={() => setIsTrue(true)}
              >
                {obj.name}
              </Link>
            </li>
          ))}
        </ul>
      </Fade>

      {/* *********************************************************************************************************** */}
    </nav>
  );
}
